import { observer } from 'mobx-react-lite'
import React, { useContext, useEffect, useState } from 'react'
import { SearchContext } from '../../../../../contexts/SearchContext'
import axiosService from '../../../../../utils/AxiosService'
import ReactMultiSelect from '../../../../FormComponents/ReactMultiSelect'

export default observer(function AudienceAgeGroupFilter() {
  const { search } = useContext(SearchContext)

  const [audienceAgeGroupOptions, setAudienceAgeGroupOptions] = useState([])

  useEffect(() => getAudienceAgeGroupOptions(), [])

  const getAudienceAgeGroupOptions = () => {
    axiosService.get(`/api/project_manager/authentications/audience_age_groups`)
    .then(age_groups => setAudienceAgeGroupOptions(age_groups.map((ageGroup) => ({ label: ageGroup.name, value: ageGroup.id }))))
  }

  const setAudienceAgeGroupFilter = (age_groups) => {
    search.audience_age_groups = age_groups.map(ageGroup => ageGroup.value)
    search.selectedAudienceAgeGroups = age_groups
    search.order = age_groups.length ? 'audience_age_groups' : 'reach'
  }

  return (
    <div className="w-full">
      <ReactMultiSelect
        placeholder="Any age"
        name="filter"
        onChange={setAudienceAgeGroupFilter}
        options={audienceAgeGroupOptions}
        value={search.selectedAudienceAgeGroups}
        disableSearch
        hasSelectAll={false}
      />
    </div>
  )
})